import { useState } from "react";
import { useConnection } from "wagmi";
import { Link } from "../components/Link";
import { Dot } from "../components/ui";
import { ConnectButton } from "../wallet/ConnectButton";
import { shortAddress } from "../wallet/address";
import { useStreamStatus } from "../state/account";
import { useValuations } from "../state/valuation";
import { usd } from "../lib/num";
import type { Route } from "../router";
import { setMuted, unlock, useMuted } from "../game/fx";
import { AccountSheet } from "./AccountSheet";

function AccountButton() {
  const { address, status } = useConnection();
  const stream = useStreamStatus();
  const valued = useValuations();
  const [open, setOpen] = useState(false);
  if (status !== "connected" || !address) return <ConnectButton size="sm" />;
  const tone = stream === "live" ? "up" : stream === "off" ? "off" : "warn";
  return (
    <>
      <button type="button" className="account-btn" onClick={() => setOpen(true)} aria-label="Account">
        <Dot tone={tone} />
        {valued && <span className="num account-equity">{usd(valued.equity)}</span>}
        <span className="mono account-addr">{shortAddress(address.toLowerCase())}</span>
      </button>
      <AccountSheet open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export function TopBar({ route }: { route: Route }) {
  const trading = route.view === "trade" || route.view === "portfolio";
  return (
    <header className="topbar">
      <div className="topbar-inner">
        <Link className="wordmark" href="/" aria-label="newspaper.hl home">
          newspaper<span>.hl</span>
        </Link>
        <span className="topbar-spacer" />
        <SoundButton />
        {trading ? (
          <AccountButton />
        ) : (
          <Link href="/trade/BTC" className="topbar-link">
            Trade live
          </Link>
        )}
      </div>
    </header>
  );
}

/** Sound on or off; on by default, remembered. */
function SoundButton() {
  const muted = useMuted();
  return (
    <button
      type="button"
      className="sound-btn"
      aria-pressed={!muted}
      aria-label={muted ? "Sound off" : "Sound on"}
      title={muted ? "Sound off" : "Sound on"}
      onClick={() => {
        setMuted(!muted);
        if (muted) unlock();
      }}
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M3 7h3l4-3v10l-4-3H3z" />
        {muted ? <path d="M12.5 7l3.5 4M16 7l-3.5 4" /> : <path d="M12.5 6.5a3.5 3.5 0 0 1 0 5M14.5 4.5a6.5 6.5 0 0 1 0 9" />}
      </svg>
    </button>
  );
}
